import { Toaster } from 'react-hot-toast';

const Toast = () => {
  return (
    <Toaster 
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        duration: 3000,
        style: {
          background: '#333',
          color: '#fff',
        },
      }}
    />
  );
};

export default Toast; 